import { isPlatformSuperAdmin } from '../../../utils/isPlatformSuperAdmin.ts';

/** Only platform super admins may create business functions. */
export function canCreateBusinessFunction(userInfo) {
  if (!userInfo) return false;
  return userInfo.is_superuser === true || isPlatformSuperAdmin(userInfo);
}
